import OrderList from '@/views/order/order-list.vue';

export default [
    {
        path:'/order-list',
        component: OrderList,
        name: 'orderList'
    }

]